import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1956f36c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-statistics-internal" }
const _hoisted_2 = {
  key: 0,
  class: "options-error",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" }, null, -1))
const _hoisted_4 = { class: "customer-cell" }
const _hoisted_5 = { key: 2 }

import { computed, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import { saveAs } from 'file-saver'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import { useStore } from '@/store'
import type { CrudSortOrder } from '@/types/crud'
import type { CrudSelectOption } from '@/types/crud-config'
import {
  createSearchItems,
  tableColumns
} from './customer-statistics-internal.config'
import {
  fetchCustomerStatisticsInternalPage,
  exportCustomerStatisticsInternal,
  fetchSearchOptions
} from './customer-statistics-internal.service'
import type { CustomerStatisticsInternalFilters } from './customer-statistics-internal.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerStatisticsInternal',
  setup(__props) {

const store = useStore()
const canList = usePermission('customerStatisticsInternal', 'list')
const canDownload = usePermission('customerStatisticsInternal', 'download')
const searchItems = ref(createSearchItems())
const exporting = ref(false)
const optionsLoading = ref(false)
const optionsError = ref('')

const createFilters = (): CustomerStatisticsInternalFilters => ({
  corpId: '',
  sid: '',
  usedBy:
    store.state.login.userInfo.isManager != '1'
      ? store.state.login.userInfo.realName
      : '',
  uname: '',
  isNewRepeat: '',
  isDeletedWithin24Hours: '',
  isDeleted: '',
  isInAfterSales: '',
  hasCallOnAssignedDay: '',
  hasConnectedCallOnAssignedDay: '',
  isNoDevelopPendingTransfer: '',
  uid: '',
  unionid: '',
  thirdParty: '',
  groupName: '',
  sourceLabel: '',
  createdAtRange: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
})

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  lastSuccessfulQuery,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  changeSort,
  refresh
} = usePagedCrud({
  createFilters,
  fetchPage: fetchCustomerStatisticsInternalPage
})

const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

function runQuery(action: () => Promise<boolean>) {
  return canList ? action() : Promise.resolve(false)
}

function handleSearch() {
  const hasFilter = Object.values(filters).some((value) =>
    Array.isArray(value)
      ? value.some((item) => item !== '')
      : value !== '' && value !== null && value !== undefined
  )
  if (!hasFilter) {
    ElMessage.warning('请至少选择一个筛选条件后再查询')
    return
  }
  return runQuery(search)
}

function handleSortChange(value: {
  prop?: string
  order?: CrudSortOrder | null
}) {
  return runQuery(() =>
    changeSort(
      value.prop && value.order
        ? { prop: value.prop, order: value.order }
        : undefined
    )
  )
}

async function loadOptions() {
  optionsLoading.value = true
  optionsError.value = ''
  try {
    const options: Record<string, CrudSelectOption[]> =
      await fetchSearchOptions()
    searchItems.value.forEach((item) => {
      if (item.type === 'select' && options[item.prop])
        item.options = options[item.prop]
    })
  } catch (cause) {
    optionsError.value =
      cause instanceof Error ? cause.message : '筛选选项加载失败'
  } finally {
    optionsLoading.value = false
  }
}

async function download() {
  if (!canList || !canDownload || !lastSuccessfulQuery.value) return
  exporting.value = true
  try {
    saveAs(
      await exportCustomerStatisticsInternal(lastSuccessfulQuery.value),
      '客户查询（对内）.xlsx'
    )
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '导出失败')
  } finally {
    exporting.value = false
  }
}

const positiveStatusFields = [
  'isInAfterSales',
  'hasCallOnAssignedDay',
  'hasConnectedCallOnAssignedDay'
]

onMounted(() => {
  if (canList) {
    loadOptions()
    load()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: searchItems.value,
      loading: _unref(loading),
      onSearch: handleSearch,
      onReset: _cache[0] || (_cache[0] = ($event: any) => (runQuery(_unref(reset))))
    }, null, 8, ["model", "items", "loading"]),
    (optionsError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(" 筛选选项加载失败：" + _toDisplayString(optionsError.value) + " ", 1),
          _createVNode(_component_el_button, {
            type: "text",
            loading: optionsLoading.value,
            onClick: loadOptions
          }, {
            default: _withCtx(() => [
              _createTextVNode("重试")
            ]),
            _: 1
          }, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "row-key": "",
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      onPageChange: _cache[1] || (_cache[1] = ($event: any) => (runQuery(() => _unref(changePage)($event)))),
      onPageSizeChange: _cache[2] || (_cache[2] = ($event: any) => (runQuery(() => _unref(changePageSize)($event)))),
      onSortChange: handleSortChange,
      onRetry: _cache[3] || (_cache[3] = ($event: any) => (runQuery(_unref(refresh))))
    }, {
      title: _withCtx(() => [
        _createTextVNode("客户查询（对内）")
      ]),
      actions: _withCtx(() => [
        (_unref(canList) && _unref(canDownload))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: exporting.value,
              disabled: _unref(loading) || !!errorMessage.value || !_unref(lastSuccessfulQuery),
              onClick: download
            }, {
              default: _withCtx(() => [
                _createTextVNode("导出")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableColumns), (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: column.prop,
            prop: column.prop,
            label: column.label,
            "min-width": column.minWidth,
            align: column.align || 'center',
            sortable: column.sortable,
            "show-overflow-tooltip": ""
          }, _createSlots({
            default: _withCtx(({ row }) => [
              (column.slot === 'consumer')
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    content: `${row.uname} (${row.remark})`,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_avatar, {
                          shape: "square",
                          size: 30,
                          src: row.avatar
                        }, null, 8, ["src"]),
                        _createElementVNode("span", null, _toDisplayString(row.uname) + " (" + _toDisplayString(row.remark) + ")", 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["content"]))
                : (column.slot)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      size: "small",
                      type: 
              row[column.prop] == 1
                ? positiveStatusFields.includes(column.prop)
                  ? 'success'
                  : 'danger'
                : 'info'
            ,
                      effect: row[column.prop] == 1 ? 'dark' : 'plain'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row[column.prop] == 1 ? '是' : '否'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type", "effect"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row[column.prop]), 1))
            ]),
            _: 2
          }, [
            (column.headerTip)
              ? {
                  name: "header",
                  fn: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      content: column.headerTip,
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(column.label) + " ", 1),
                          _hoisted_3
                        ])
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["prop", "label", "min-width", "align", "sortable"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message"])
  ]))
}
}

})